import { useCallback, useState } from 'react'

const STORAGE_KEY = 'ecomm.sidebar.open'

function readInitial(defaultOpen: boolean): boolean {
  if (typeof window === 'undefined') return defaultOpen
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw === '1') return true
    if (raw === '0') return false
  } catch {
    /* intentionally ignored */
  }
  return defaultOpen
}

export function useSidebarState(isMobile: boolean) {
  const [isOpen, setIsOpen] = useState<boolean>(() => readInitial(!isMobile))

  const toggle = useCallback(() => {
    setIsOpen(prev => {
      const next = !prev
      try {
        window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0')
      } catch {
        /* intentionally ignored */
      }
      return next
    })
  }, [])

  return { isOpen, toggle }
}
